import React from 'react'
import { FleetSection } from '../../../../../../shared/sso-workspace/fleet-page'
import { FieldLock, LOCK_LINE, isScim } from '../common/managed-by'
import { ResetSignInLink } from '../user-login-edit/user-reset-sign-in'
import { addedText, lastActiveText, signInText } from './person-words'

// Who this person is, read-only, in both states (owner 2026-10-29: a
// removed person's page had an empty left half): name and address exactly
// as stored, how they sign in, when they were last active (content's
// last_active: any signed-in request, so a sign-in counts), and when and
// how they were added. The names and address are never edited here; a
// person the identity provider provisions has them locked, with the line
// saying where to change them.
export const PersonDetails = ({ person, removed }) => {
  const managedBy = person.managedBy
  const name = `${person.firstName || ''} ${person.lastName || ''}`.trim()
  const added = addedText(person)
  const active = lastActiveText(person.lastActive)
  return (
    <FleetSection id="pp-details" title="Details">
      <dl className="sw-dl pp-dl">
        <dt>Name</dt>
        <dd data-testid="pp-name">{name || <span className="sw-hint">No name given</span>}<FieldLock managedBy={managedBy} /></dd>
        <dt>Email</dt>
        <dd data-testid="pp-email" className="pp-as-stored">{person.email}<FieldLock managedBy={managedBy} /></dd>
        <dt>Signs in</dt>
        <dd data-testid="pp-signin">{signInText(managedBy)}</dd>
        <dt>Last active</dt>
        <dd data-testid="pp-last-active"><span title={active.title || undefined}>{active.text}</span></dd>
        <dt>Added</dt>
        <dd data-testid="pp-added">
          {added.when || <span className="sw-hint">Not recorded</span>}
          {added.how && <span className="d-block sw-hint">{added.how}</span>}
        </dd>
      </dl>
      {isScim(managedBy) && <p className="sw-hint mt-3 mb-0" data-testid="managed-lock-line">{LOCK_LINE}</p>}
      {!removed && <ResetSignInLink userLogin={person} />}
    </FleetSection>
  )
}
